import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IRequest } from "../models";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../AppRoutes";
import { useSelector } from "../../../../../store/store";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { useGetMyApprovals } from "../hooks";
import { Skeleton } from "antd";
import { exportExcel } from "../utils";
import { getStatus } from "../../summary-employee-request/utils/get-status";

export const MyApprovals: React.FC = () => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const columns: ColumnsType<IRequest> = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render(value, record, index) {
        return getDDMMYYYFormat(record?.createdDateTime);
      },
    },
    {
      title: "Người tạo",
      dataIndex: "createdBy",
      key: "createdBy",
      render(value, record, index) {
        return record?.createdBy?.user?.displayName;
      },
    },
    {
      title: "Yêu cầu",
      dataIndex: "type",
      key: "type",
      render(value, record, index) {
        return <span className="flag warning">Yêu cầu</span>;
      },
    },
    {
      title: "Cơ quan đơn vị",
      dataIndex: "eDepartment",
      key: "eDepartment",
      render(value, record, index) {
        return record?.fields?.eDepartment;
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render(value, record, index) {
        const status = getStatus({
          currentUser: currentUserName,
          requestStatus: record.fields.eRequestStatus,
          steps: [
            {
              status: record.fields.eApprovedStatus,
              approver: record.fields.eApprovedBy,
            },
            {
              status: record.fields.eApprovedByITLeadStatus,
              approver: record.fields.eApprovedByITLead,
            },
            {
              status: record.fields.eApprovedByITHeadStatus,
              approver: record.fields.eApprovedByITHead,
            },
          ],
        });

        return <ApprovalStatus status={status} />;
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "Download",
      key: "Download",
      render(value, record, index) {
        return (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              exportExcel(record);
            }}
          >
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        );
      },
    },
  ];

  const { data, isLoading } = useGetMyApprovals();

  return (
    <>
      {!isLoading && (
        <Table
          columns={columns}
          dataSource={data}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(
                  Routes.courseStaffDetailPage.path.replace(":id", record.id)
                );
              },
            };
          }}
          rowClassName="cursor-pointer"
        />
      )}
      {isLoading && <Skeleton />}
    </>
  );
};
